import { useQuery } from "@tanstack/react-query"
import { useAuth } from "@/contexts/AuthContext"
import { supabase } from "@/lib/supabase"

export type ViewerProfileRow = Record<string, any> | null

type UseViewerProfileOptions = {
  enabled?: boolean
}

export function useViewerProfile(options: UseViewerProfileOptions = {}) {
  const { currentUser } = useAuth()
  const userId = String(currentUser?.id || "").trim()

  return useQuery<ViewerProfileRow>({
    queryKey: ["profiles", "viewer", userId],
    enabled: Boolean(userId) && (options.enabled ?? true),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 1,
    queryFn: async () => {
      const res = await supabase.from("profiles").select("*").eq("id", userId).maybeSingle()
      if (res.error) throw res.error
      return (res.data || null) as ViewerProfileRow
    },
  })
}
